var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00845931 8.6948C0.00845931 8.07615 0.015909 7.45751 0.0233933 6.836L0.0233934 6.83599C0.0271878 6.52089 0.030991 6.20506 0.0338368 5.88813C0.0338368 2.48283 2.16556 0 5.10936 0H8.89063C11.8344 0 13.9662 2.48283 13.9662 5.88813C13.9915 7.25221 14 8.61629 14 9.99019C14 11.3641 13.9915 12.7478 13.9662 14.1119C13.9662 17.5172 11.8344 20 8.89063 20H5.10936C2.16556 20 0.0338368 17.5172 0.0338368 14.1021C0.0169184 12.8165 0 11.5015 0 10.1668L0.00845931 8.6948ZM8.27973 17.64V17.8C8.27973 18.4736 7.71653 19 6.99973 19C6.29999 19 5.71973 18.4736 5.71973 17.8V17.64C5.71973 16.984 6.29999 16.44 6.99973 16.44C7.71653 16.44 8.27973 16.984 8.27973 17.64ZM2.01671 6.4434C2.01136 6.84738 2.00604 7.2495 2.00604 7.65162L2 8.60844C2 9.47596 2.01208 10.3307 2.02417 11.1663C2.02417 13.3862 3.54683 15 5.64955 15H8.35045C10.4532 15 11.9758 13.3862 11.9758 11.1727C11.994 10.2861 12 9.38665 12 8.49362C12 7.60059 11.994 6.71393 11.9758 5.82728C11.9758 3.61384 10.4532 2 8.35045 2H5.64955C3.54683 2 2.02417 3.61384 2.02417 5.82728C2.02214 6.0333 2.01942 6.23859 2.01671 6.4434Z",
    fill: "#0EC99E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.7cff251f7127cc5ceb7608e8786c2056.svg";
export { ForwardRef as ReactComponent };